export interface AgeYearsOldProps {
  ages_from: number | null
  ages_to: number | null
}

const renderAgeText = (ages_from: number | null, ages_to: number | null): string => {
  if (typeof ages_from === 'number' && ages_from === 0 && ages_to === null) {
    return 'All ages'
  }

  if ((!ages_from && !ages_to) || (ages_to && ages_to < ages_from!) || (ages_from === 0 && ages_to === 0)) {
    return 'Ages unknown'
  }

  if (!ages_from && ages_to === 0) {
    return 'Ages unknown'
  }

  if (!ages_from && ages_to && ages_to > 0) {
    return `Up to ${ages_to} ${ages_to === 1 ? 'year old' : 'years old'}`
  }

  if (ages_from && (!ages_to || ages_to === 0)) {
    return `${ages_from}+ years old`
  }

  if (ages_from === ages_to) {
    return `${ages_from} year-olds`
  }

  return `${ages_from}-${ages_to} years old`
}
export const AgesText = ({ ages_from, ages_to }: AgeYearsOldProps) => {
  return <span data-testid="ages-label">{renderAgeText(ages_from, ages_to)}</span>
}
